export function getWpAjaxEnv() {
  const ajaxurl = window.GBCONF
    ? window.GBCONF.ajaxurl
    : '/wp-admin/admin-ajax.php';
  const nonce = window.GBCONF ? window.GBCONF.nonce : '';
  const pluginUrl = window.GBCONF ? window.GBCONF.pluginUrl : '';
  return { ajaxurl, nonce, pluginUrl };
}

export const importDataFromUrl = (data) => {
  const {
    setGeneralState,
    setMusicState,
    setSocialsState,
    setSelectedLayout,
    setCroppersCount,
    setSelectedMultipleZoomIndex,
    setMultipleGap,
    setCroppers,
  } = data;
  const params = new URLSearchParams(window.location.search);

  const cartStr = params.get('edit');

  const configStr = localStorage.getItem(cartStr);
  console.log(configStr);

  if (configStr) {
    try {
      const config = JSON.parse(configStr);
      console.log('CONFIG', config);
      setGeneralState({ ...config.general, cartKey: cartStr, envLoaded: true });
      setSocialsState(config?.socials);
      setMusicState(config?.music);

      if (config.selectedLayout) setSelectedLayout(config.selectedLayout);
      if (config.multipleGap) setMultipleGap(config.multipleGap);
      // if (config.croppersCount) setCroppersCount(config.croppersCount);
      if (config.croppers) setCroppers(config.croppers);
      if (config.selectedMultipleZoomIndex)
        setSelectedMultipleZoomIndex(config.selectedMultipleZoomIndex);
    } catch (e) {
      console.error(e);
    }
    setGeneralState({ envLoaded: true });
  }
  //
  // fetch('/wp-json/wp/v2/users/me', { credentials: 'include' })
  //   .then((res) => (res.ok ? res.json() : null))
  //   .then((user) => user && console.log('Logged in as', user))
  //   .catch(() => console.log('User not logged in'));
};
